import { NgModule } from '@angular/core';
import { RmtCurrencyPipe } from './rmt-currency/rmt-currency';
import { RawHtmlPipe } from './raw-html/raw-html';

@NgModule({
  declarations: [
    RmtCurrencyPipe,
    RawHtmlPipe,
  ],
  imports: [],
  exports: [
    RmtCurrencyPipe,
    RawHtmlPipe,
  ]
})
export class PipesModule { }



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts